// DD Upsell UI: shipping progress bar + one-tap rec row. Pure helpers UMD-exported for tests.
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) { module.exports = api; }
  else { root.DDUpsellUI = api; }
  if (typeof document !== 'undefined') { api._autoBoot(); }
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }

  function buildAddPayload(variantId, source) {
    return { items: [{ id: variantId, quantity: 1, properties: { _dd_rec_source: source } }] };
  }

  var DISCOUNT_RATE = 0.10; // keep in sync with the live automatic discounts (see DISCOUNTS.md)

  function discountedCents(cents) {
    return Math.round(cents * (1 - DISCOUNT_RATE));
  }

  function priceHtml(cents, badge) {
    if (!badge) return money(cents);
    return '<s>' + money(cents) + '</s> <strong>' + money(discountedCents(cents)) + '</strong>';
  }

  function renderBar(el, totalCents, thresholdCents, badge, hasJeans) {
    var p = DDRecEngine.shippingProgress(totalCents, thresholdCents);
    var msg = p.reached
      ? '<p class="dd-bar__msg dd-bar__msg--reached">You unlocked free shipping 🎉</p>' +
        (badge
          ? '<p class="dd-bar__sub">Add additional items at discounted prices.</p>'
          : '<p class="dd-bar__sub">Keep going — we picked more American-made goods in your size below.</p>')
      : '<p class="dd-bar__msg">You’re <strong>' + money(p.remainingCents) + '</strong> from free shipping</p>';
    el.innerHTML = msg + '<div class="dd-bar__track"><div class="dd-bar__fill" style="width:' + p.pct + '%"></div></div>';
  }

  function addToCart(variantId, source, onDone) {
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(buildAddPayload(variantId, source))
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { onDone(true); })
      .catch(function () { onDone(false); });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function buildCartItems(raw) {
    return raw.map(function (it) {
      var system = (it.type === 'Jeans' || it.type === 'Belt') ? 'waist' : 'alpha';
      var parsed = DDRecEngine.parseVariantTitle(it.variantTitle, system);
      return { productId: it.productId, type: it.type, gender: it.gender, wash: it.wash,
               waist: parsed.waist, inseam: parsed.inseam, alpha: parsed.alpha };
    });
  }

  function recHeading(hasJeans, isPdp) {
    if (isPdp) return 'Complete the look';
    return hasJeans
      ? 'We manufacture more than just jeans. Here are some recommendations in stock in your size based on your cart selection.'
      : 'Here are some great additions to get there…';
  }

  function renderRecs(el, recs, source, badge, heading, showDiscount) {
    if (!recs.length) { el.hidden = true; return; }
    var html = '<h3 class="dd-rec__heading">' + escapeHtml(heading || 'Goes with your order') + '</h3>';
    recs.forEach(function (r, i) {
      html += '<div class="dd-rec__item" data-dd-rec-idx="' + i + '">' +
        '<img class="dd-rec__img" src="' + escapeHtml(r.image) + '" alt="" loading="lazy" width="56" height="56">' +
        '<div class="dd-rec__meta"><span class="dd-rec__title">' + escapeHtml(r.title) + '</span>' +
        '<span class="dd-rec__price">' + priceHtml(r.price, showDiscount ? badge : null) +
        (showDiscount && badge ? ' <em class="dd-rec__badge">' + escapeHtml(badge) + '</em>' : '') + '</span></div>';
      if (r.sizeButtons && r.sizeButtons.length > 1) {
        html += '<span class="dd-rec__btns">' + r.sizeButtons.map(function (b) {
          return '<button type="button" class="dd-rec__add button" data-dd-add="' + b.variantId + '">Add ' + escapeHtml(b.label) + '</button>';
        }).join('') + '</span>';
      } else if (r.variantId) {
        html += '<button type="button" class="dd-rec__add button" data-dd-add="' + r.variantId + '">Add · ' + money(showDiscount && badge ? discountedCents(r.price) : r.price) + '</button>';
      } else {
        html += '<select class="dd-rec__size" aria-label="Choose size"><option value="">Size…</option>' +
          r.sizeOptions.map(function (o) { return '<option value="' + o.variantId + '">' + escapeHtml(o.label) + '</option>'; }).join('') +
          '</select><button type="button" class="dd-rec__add button" data-dd-add-select disabled>Add</button>';
      }
      html += '</div>';
    });
    el.innerHTML = html;
    el.hidden = false;
    // Keep our widget's change events out of the theme's <cart-items> quantity handler
    // (otherwise Dawn shows "you can only add in increments of undefined")
    el.addEventListener('change', function (e) { e.stopPropagation(); });
    function afterAdd(btn, ok) {
      if (ok) {
        btn.textContent = 'Added ✓';
        window.location.reload(); // server re-renders cart with fresh totals + rec exclusions
      } else { btn.disabled = false; }
    }
    el.querySelectorAll('[data-dd-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.disabled = true;
        addToCart(parseInt(btn.getAttribute('data-dd-add'), 10), source, function (ok) { afterAdd(btn, ok); });
      });
    });
    el.querySelectorAll('.dd-rec__item select').forEach(function (sel) {
      var btn = sel.parentElement.querySelector('[data-dd-add-select]');
      sel.addEventListener('change', function () { btn.disabled = !sel.value; });
      btn.addEventListener('click', function () {
        btn.disabled = true;
        addToCart(parseInt(sel.value, 10), source, function (ok) { afterAdd(btn, ok); });
      });
    });
  }

  function pdpAnchor(row) {
    var variantTitle = '';
    // Primary: Dawn keeps the selected variant id in .product-variant-id / [name="id"]; map id → title
    var mapEl = document.querySelector('[data-dd-pdp-variants]');
    var idInput = document.querySelector('form[action*="/cart/add"] input.product-variant-id, form[action*="/cart/add"] [name="id"]');
    if (mapEl && idInput && idInput.value) {
      try {
        var map = JSON.parse(mapEl.textContent);
        if (map[idInput.value]) variantTitle = map[idInput.value];
      } catch (e) { /* fall through */ }
    }
    if (!variantTitle) {
      var form = document.querySelector('form[action*="/cart/add"]');
      if (form) {
        var sel = form.querySelector('select[name="id"] option:checked');
        if (sel) { variantTitle = (sel.textContent || '').trim(); }
      }
    }
    if (!variantTitle) {
      var picker = document.querySelector('variant-selects, variant-radios');
      if (picker) {
        var parts = [];
        picker.querySelectorAll('select').forEach(function (s) { parts.push(s.value); });
        picker.querySelectorAll('input[type="radio"]:checked').forEach(function (rd) { parts.push(rd.value); });
        variantTitle = parts.join(' / ');
      }
    }
    var parsed = DDRecEngine.parseVariantTitle(variantTitle, 'waist');
    return { productId: parseInt(row.dataset.ddPdpProductId, 10), type: row.dataset.ddPdpType,
             gender: row.dataset.ddPdpGender || null, wash: row.dataset.ddPdpWash || null,
             waist: parsed.waist, inseam: parsed.inseam, alpha: parsed.alpha };
  }

  function parseUpsellDataFromHtml(html) {
    var m = String(html).match(/<script type="application\/json" data-dd-upsell-data>([\s\S]*?)<\/script>/);
    if (!m) return null;
    try { return JSON.parse(m[1]); } catch (e) { return null; }
  }

  function isCartMutationUrl(url) {
    return typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
  }

  function applyData(data) {
    var isEmpty = !(data.cartItems || []).length;
    var cartHasJeans = (data.cartItems || []).some(function (it) { return it.type === 'Jeans'; });
    var unlocked = DDRecEngine.shippingProgress(data.cartTotalCents, data.config.thresholdCents).reached;
    document.querySelectorAll('[data-dd-shipping-bar]').forEach(function (bar) {
      if (isEmpty) { bar.innerHTML = ''; bar.hidden = true; return; }
      bar.hidden = false;
      renderBar(bar, data.cartTotalCents, data.config.thresholdCents, data.config.badge, cartHasJeans);
    });
    document.querySelectorAll('[data-dd-rec-row]:not([data-dd-context="pdp"])').forEach(function (row) {
      if (isEmpty) { row.innerHTML = ''; row.hidden = true; return; }
      var recs = DDRecEngine.recommend({ cartItems: buildCartItems(data.cartItems), catalog: data.catalog, maxRecs: data.config.maxRecs });
      renderRecs(row, recs, 'cart', data.config.badge, recHeading(cartHasJeans, false), unlocked);
    });
  }

  function sectionIdFor(el) {
    var wrap = el.closest ? el.closest('.shopify-section') : null;
    return wrap && wrap.id ? wrap.id.replace('shopify-section-', '') : null;
  }

  function watchCartMutations(refresh) {
    // Dawn pubsub when present
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { refresh(); });
    }
    // Theme-agnostic fallback: watch fetches to cart mutation endpoints
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0] && (arguments[0].url || arguments[0]);
      var p = origFetch.apply(window, arguments);
      if (isCartMutationUrl(url)) { p.then(function () { refresh(); }).catch(function () {}); }
      return p;
    };
  }

  function boot() {
    var dataEl = document.querySelector('[data-dd-upsell-data]');
    if (!dataEl || typeof DDRecEngine === 'undefined') return;
    var data = parseUpsellDataFromHtml(dataEl.outerHTML);
    if (!data) { try { data = JSON.parse(dataEl.textContent); } catch (e) { return; } }

    applyData(data);

    // PDP rows render from the selected variant and follow size changes
    document.querySelectorAll('[data-dd-rec-row][data-dd-context="pdp"]').forEach(function (row) {
      function rerender() {
        var recs = DDRecEngine.recommend({ cartItems: [pdpAnchor(row)], catalog: data.catalog, maxRecs: data.config.maxRecs });
        renderRecs(row, recs, 'pdp', data.config.badge, recHeading(false, true), false);
      }
      rerender();
      document.addEventListener('change', function (e) {
        if (e.target.closest && e.target.closest('variant-selects, variant-radios')) {
          rerender();
          setTimeout(rerender, 500); // Dawn syncs [name="id"] async after variant change
        }
      });
      // Custom DD PDP uses .dd-chip buttons (click, not change); its handler syncs [name="id"] first
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.dd-chip')) { setTimeout(rerender, 0); }
      });
    });

    // Cart surfaces: refresh bar + recs on every cart mutation (qty change, removal, add)
    var cartNode = document.querySelector('[data-dd-shipping-bar], [data-dd-rec-row]:not([data-dd-context="pdp"])');
    if (cartNode) {
      var sectionId = sectionIdFor(cartNode);
      var pending = null;
      var refresh = function () {
        if (pending) clearTimeout(pending);
        pending = setTimeout(function () {
          pending = null;
          var url = window.location.pathname + '?section_id=' + (sectionId || 'main-cart-items');
          fetch(url).then(function (r) { return r.text(); }).then(function (html) {
            var fresh = parseUpsellDataFromHtml(html);
            if (fresh) applyData(fresh);
          }).catch(function () {});
        }, 200);
      };
      watchCartMutations(refresh);
    }
  }

  function _autoBoot() {
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
    else { boot(); }
  }

  return { buildAddPayload: buildAddPayload, money: money, escapeHtml: escapeHtml, recHeading: recHeading,
           discountedCents: discountedCents, priceHtml: priceHtml,
           parseUpsellDataFromHtml: parseUpsellDataFromHtml, isCartMutationUrl: isCartMutationUrl, _autoBoot: _autoBoot };
});
